(function(runtime) {
    var _ = runtime.components.dependencies._;
    var $ = runtime.components.dependencies.jQuery.v1_11;
    var modernizr = runtime.components.dependencies.Modernizr;

    var constants = runtime.components.constants.merge({
        dropdownSelector: function(instanceId) {
            return '#ixp_dropdown_' + instanceId
        },

        formMicrothemesMap: {
            'ixp-component-form-default': 'ixp-component-dropdown-menu-inherit',
            'ixp-component-form-light': 'ixp-component-dropdown-menu-opacity-light',
            'ixp-component-form-dark': 'ixp-component-dropdown-menu-opacity-dark'
        },

        formMicrothemesToRetainPrefix: 'ixp-component-form-style-',
        dropdownStyleMicrothemesToRetainPrefix: 'ixp-component-dropdown-',
        dropdownCustomMicrothemesToRetainPrefix: 'ixp-component-dropdown-select-',
        menuMicrothemePrefix: 'ixp-component-dropdown-menu-',
        defaultDropdownMicrotheme: 'ixp-component-dropdown-inherit',
        defaultMenuMicrotheme: 'ixp-component-dropdown-menu-inherit',

        css: {
            'dropdownRequired': 'ixp-component-dropdown-required',
            'dropdownResponsiveDisabled': 'ixp-component-dropdown-select-responsive-disabled',
            'menuResponsiveDisabled': 'ixp-component-dropdown-menu-responsive-disabled'
        },

        extensibility: {
            commands: {
                open: ':open',
                close: ':close',
                state: ':state',
                search: ':search'
            },

            events: {
                valueChanging: ':value:changing',
                valueChanged: ':value:changed',
                loading: ':loading',
                loaded: ':loaded',
                opening: ':opening',
                opened: ':opened',
                closed: ':closed'
            }
        }
    });

    runtime.components.registerExtensibility('ixp-dropdown', {
        commands: constants.extensibility.commands || {},
        events: constants.extensibility.events || {}
    });

    var statics = {
        getScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('dropdown')
                }
            };
        },

        // orientation code adapted from here http://menacingcloud.com/?c=viewportScale
        getOrientation: function() {
            var orientation = window.orientation;

            if (orientation === undefined) {
                // No JavaScript orientation support. Work it out.
                if (document.documentElement.clientWidth > document.documentElement.clientHeight) {
                    orientation = 'landscape';
                } else {
                    orientation = 'portrait';
                }

            } else if (orientation === 0 || orientation === 180) {
                orientation = 'portrait';
            } else {
                orientation = 'landscape';
            } // Assumed default, most laptop and PC screens.
            return orientation;
        },

        getViewportScale: function() {
            var viewportScale;

            // Get viewport width
            var viewportWidth = document.documentElement.clientWidth;

            // Abort. Screen width is greater than the viewport width (not fullscreen).
            if (screen.width > viewportWidth) {
                return;
            }

            // Get the orientation corrected screen width
            var orientation = this.getOrientation();
            var screenWidth = screen.width;

            if (orientation === 'portrait') {
                // Take smaller of the two dimensions
                if (screen.width > screen.height) {
                    screenWidth = screen.height;
                }
            } else {
                // Take larger of the two dimensions
                if (screen.width < screen.height) {
                    screenWidth = screen.height;
                }
            }

            // Calculate viewport scale
            viewportScale = screenWidth / window.innerWidth;
            return viewportScale;
        }
    };

    runtime.components.register('ixp-dropdown', runtime.components.InputComponentBase, {
        initialize: function(options) {
            this.$elDropdown = this.$el.find(constants.dropdownSelector(this.instanceId));

            this.useCache = true;
            this.dataSet = this.dataSet && JSON.parse(this.dataSet);
            this.dependentDataField = this.dependentDataField && JSON.parse(this.dependentDataField);

            this._createDropdown();

            if (!this.inStudio && this.dependentDataField) {
                runtime.events.on(this, 'runtime:data:' + this.dependentDataField.name + ':saving', this._onDependentDataSaving);
                this.onDependentDataSaved({
                    key: this.dependentDataContext.name,
                    value: this.dependentDataContext.hasValue
                        ? this.dependentDataContext.value
                        : this.dependentDataContext.defaultValue
                });
            }

            this._setInitialValue(this.defaultValue);
            this.listenToDropdownEvents();
        },

        listenToDropdownEvents: function() {
            this.$elDropdown.on('select2-opening' + this.eventNamespace, _.bind(this._onDropdownOpening, this));
            this.$elDropdown.on('select2-open' + this.eventNamespace, _.bind(this._onDropdownOpened, this));
            this.$elDropdown.on('select2-close' + this.eventNamespace, _.bind(this._onDropdownClosed, this));
            this.$elDropdown.on('select2-selecting' + this.eventNamespace, _.bind(this._onDropdownChanging, this));
            this.$elDropdown.on('select2-loaded' + this.eventNamespace, _.bind(this._onDropdownLoaded, this));

            runtime.events.on(this, this.state.instanceId + constants.inputs.events.formFieldInputRegistered, this._onFormFieldInputRegistered);
        },

        _onFormFieldInputRegistered: function (e) {
            var textFieldLabel = $(e.labelContainerSelector).get(0);
            this._setAriaLabelAttribute(textFieldLabel);
        },

        onListenToInputEvents: function() {
            var onInputChanged = _.bind(this.onInputChanged, this);
            this.$el.on('change' + this.eventNamespace, constants.inputSelector, _.bind(_.partial(this._onDropdownChanged, onInputChanged), this));
        },

        onGetCommandMap: function() {
            var commands = {};
            commands[constants.extensibility.commands.open] = {
                fn: this._onCommandOpen
            };
            commands[constants.extensibility.commands.close] = {
                fn: this._onCommandClose
            };
            commands[constants.extensibility.commands.state] = {
                fn: this._onCommandState
            };
            commands[constants.extensibility.commands.search] = {
                fn: this._onCommandSearch
            };
            return commands;
        },

        _onCommandOpen: function() {
            this.$elDropdown.select2('open');
        },

        _onCommandClose: function() {
            this.$elDropdown.select2('close');
        },

        _onCommandState: function(options) {
            options || (options = {});

            if (options.enabled === true || options.enabled === false) {
                this.$elDropdown.select2('enable', options.enabled);
            }

            if (options.readonly === true || options.readonly === false) {
                this.$elDropdown.select2('readonly', options.readonly);
            }

            if (options.useCache === true || options.useCache === false) {
                this.useCache = options.useCache;
                if (!options.useCache) {
                    this.choicesCache = null;
                }
            }
        },

        _onCommandSearch: function(options) {
            options || (options = {});
            this.$elDropdown.select2('search', options.value);
        },

        _onDependentDataSaving: function(e) {
            this.choicesCache = null;

            this.dependentChangingTimer = _.delay(function(me) {
                me.dependentChangingTimer = 0;
                me._onCommandState({readonly: true});
            }, 500, this);
        },

        onDependentDataSaved: function(e) {
            if (this.dependentChangingTimer) {
                clearTimeout(this.dependentChangingTimer);
                this.dependentChangingTimer = 0;
            }
            this.choicesCache = null;

            var enabled = !this.isValueEmpty(e.value);
            this._onCommandState({enabled: enabled, readonly: false});

            // If we currently have a value, then reset it to make sure it is still valid
            var value = this.getValue();
            if (!this.isValueEmpty(value)) {
                this.setValue(value, {save: false, trigger: false});
            }
        },

        _onInputWrapClicked: function(e) {
            this.setFocus();
        },

        _onDropdownChanging: function(e) {
            var ee = {
                value: e.val,
                choice: {
                    value: e.choice.id,
                    name: e.choice.text
                },
                required: this.state.required,
                cancel: false
            };
            this.triggerExtensibility(constants.extensibility.events.valueChanging, ee);

            if (ee.cancel) {
                e.preventDefault();
                return;
            }
        },

        _onDropdownChanged: function(onInputChanged, e) {
            var ee = {
                value: e.val,
                choice: {
                    value: e.added.id,
                    name: e.added.text
                },
                required: this.state.required
                //previous: {
                //    value: e.removed.id,
                //    name: e.removed.text
                //}
            };
            this.triggerExtensibility(constants.extensibility.events.valueChanged, ee);

            onInputChanged(e);
        },

        _onDropdownOpening: function(e) {
            if (this.dependentChangingTimer) {
                e.preventDefault();
                return;
            }

            var ee = {
                cancel: false
            };
            this.triggerExtensibility(constants.extensibility.events.opening, ee);

            if (ee.cancel) {
                e.preventDefault();
                return;
            }

            if (document.activeElement) {
                // this will dismiss open mobile keyboards when the dropdown opens
                document.activeElement.blur();
            }

            this.$elDropdown.select2('dropdown').css('pointer-events', 'none');

            if (modernizr.mobiledevice) {
                // reset the viewport scale to 1 for the mobile overlay
                var meta = $('meta[name=viewport]');
                if (meta.length) {
                    this.initialContent = meta.attr('content');
                    this.currentViewportScale = statics.getViewportScale();
                    var disabledZoom = this.initialContent + ', maximum-scale=1, user-scalable=no';
                    meta.attr('content', disabledZoom);
                }
            }
        },

        _onDropdownOpened: function(e) {
            _.delay(_.bind(function() {
                this.$elDropdown.select2('dropdown').css('pointer-events', 'auto');
            }, this), 100);

            this.triggerExtensibility(constants.extensibility.events.opened);
        },

        _onDropdownClosed: function(e) {
            if (modernizr.mobiledevice) {
                var meta = $('meta[name=viewport]');
                if (meta.length && this.initialContent) {
                    if (this.currentViewportScale) {
                        meta.attr('content', this.initialContent + ',minimum-scale=' + this.currentViewportScale + ', maximum-scale=' + this.currentViewportScale + ', user-scalable=no');
                    }

                    meta.attr('content', this.initialContent);
                }
            }

            this.triggerExtensibility(constants.extensibility.events.closed);
        },

        _onDropdownLoaded: function(e) {
            this.triggerExtensibility(constants.extensibility.events.loaded);
        },

        onDestroy: function() {
            if (this.$elDropdown && this.$elDropdown.length) {
                this.$elDropdown.off(this.eventNamespace);
            }
        },

        setFocus: function() {
            var $field = this.$el.closest(constants.inputs.formFieldSelector);
            if ($field.length) {
                $field.attr('tabindex', 0);
                $field.focus();
                $field.removeAttr('tabindex');
            }
            this.$elDropdown.select2('focus');
        },

        getValue: function() {
            return this.$elDropdown.val();
        },

        onSetValue: function(value, options) {
            // respondent data
            if (options.useMetadata) {
                var metadata = JSON.parse(this.dataContext.metadata);
                this.$elDropdown.select2('data', {id: metadata.choiceValue, text: metadata.choiceName});
                return;
            }

            // lookup for matching value
            return this._findMatchingChoice(value)
                .then(_.bind(function(choice) {
                    this.$elDropdown.select2('data', choice);
                    return choice && choice.id;
                }, this));
        },

        _findMatchingChoice: function(value) {
            if (this.isValueEmpty(value)) {
                return Promise.resolve(null);
            }

            return this._getChoices()
                .then(function(choices) {
                    var choice;
                    for (var i = 0; i < choices.length; i++) {
                        choice = choices[i];
                        if (choice.id === value) {
                            return choice;
                        }
                    }

                    return null;
                });
        },

        isSaveRequired: function(value) {
            // Are we optional and empty?
            if (!this.state.required && this.isValueEmpty(value)) {
                // If our value is different than the saved value and we aren't already valid, then we need to delete the saved value
                if (this.dataContext.hasValue && value != this.dataContext.value) {
                    return {method: 'DELETE'};
                } else {
                    return false;
                }
            }

            return runtime.components.InputComponentBase.prototype.isSaveRequired.apply(this, arguments);
        },

        onValidateValue: function(value) {
            // JHP: can we always return true here?
            return true;
        },

        _onInputFocused: function(e) {
            this.focused = true;

            _.defer(function(me) {
                if (me.focused) {
                    me.$(e.target).select();
                }
            }, this);
        },

        _onInputBlurred: function(e) {
            this.focused = false;
        },

        _getChoices: function(search) {
            var promise;

            if (this.choicesCache) {
                promise = Promise.resolve(this.choicesCache);
            } else if (this.dataSet) {
                promise = this._fetchChoicesFromDataSet(search);
            } else {
                promise = this._fetchChoicesFromExtensibility(search);
            }

            if (!search) {
                return promise;
            }

            return promise.then(_.bind(function(choices) {
                return this._searchChoices(choices, search)
            }, this));
        },

        _fetchChoicesFromDataSet: function(search) {
            var url = '/admin/api/v1/datasets/' + this.dataSet.id + '/entries/query';

            if (this.dependentDataField) {
                var data = runtime.data.model.get(this.dependentDataField.name);
                if (!data || this.isValueEmpty(data.value)) {
                    return Promise.resolve([]);
                }

                url += '?filter1=' + data.value;
            }

            return Promise.resolve($.ajax({
                url: url,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'GET'
            })).then(_.bind(this._parseChoices, this));
        },

        _fetchChoicesFromExtensibility: function(search) {
            var ee = {
                choices: null,
                filter: this.dependentDataField && this.dependentDataField.value,
                search: search,
                useCache: this.useCache
            };
            this.triggerExtensibility(constants.extensibility.events.loading, ee);

            this.useCache = ee.useCache;

            if (ee.choices instanceof Promise) {
                return ee.choices.then(_.bind(this._parseChoices, this));
            }
            if (ee.choices instanceof Array) {
                return Promise.resolve(ee.choices).then(_.bind(this._parseChoices, this));
            }

            return Promise.reject({e: ee});
        },

        _parseChoices: function(response) {
            // remove "placeholder" item
            if (response.length && !response[0].value) {
                response.shift();
            }

            var choices = new Array(response.length);

            var choice,
                entry;
            for (var i = 0; i < response.length; i++) {
                entry = response[i];
                choice = choices[i] = {
                    id: entry.value,
                    text: entry.name,
                    disabled: !!entry.disabled,
                    normalizedText: entry.name.toUpperCase()
                };

                if (entry.children && entry.children instanceof Array) {
                    choice.children = this._parseChoices(entry.children);
                }
            }

            if (this.useCache) {
                this.choicesCache = choices;
            }

            return choices;
        },

        _searchChoices: function(choices, search) {
            search = search.toUpperCase();

            var matches = [];

            var choice;
            for (var i = 0; i < choices.length; i++) {
                choice = choices[i];

                if (choice.children && choice.children instanceof Array) {
                    var matchedChildren = [];

                    var children = choice.children;
                    var child;
                    for (var j = 0; j < children.length; j++) {
                        child = children[j];
                        if (child.normalizedText.indexOf(search) >= 0) {
                            matchedChildren.push(child);
                        }
                    }

                    if (matchedChildren.length) {
                        // Copying the object here, since we are modifying the children array
                        matches.push({
                            id: choice.id,
                            text: choice.text,
                            disabled: choice.disabled,
                            normalizedText: choice.normalizedText,
                            children: matchedChildren
                        });
                    }
                } else if (choice.normalizedText.indexOf(search) >= 0) {
                    matches.push(choice);
                }
            }

            return matches;
        },

        _createDropdown: function() {
            var config = {
                initSelection: function() {
                }, // This needs to be a noop, as we've got custom logic in setValue, and select2's default initSelection will trigger our ajax call to get the data set
                allowClear: this.showClearButton,
                placeholder: this.placeholder,
                minimumResultsForSearch: this.showSearch ? 1 : -1,
                dropdownAutoWidth: true,
                adaptDropdownCssClass: _.bind(this._adaptDropdownCssClasses, this),
                data: []
            };

            if (!this.inStudio) {
                config.query = _.bind(function(query) {
                    this._getChoices(query.term)
                        .then(function(choices) {
                            query.callback({results: choices});
                        });
                }, this);
            }

            this.$elDropdown.select2(config);

            // ensures the dropdown's width matches the components width
            this.$elDropdown.select2('container').css('width', '100%');

            this.$elDropdown.select2('dropdown').prepend('<div class="select2-drop-close"><span class="select2-drop-close-label">Close</span></div>');

            $('.select2-drop-close').on('click', _.bind(function() {
                this.$elDropdown.select2('close');
            }, this));

            var dataFieldObj = JSON.parse(this.dataField);

            if (dataFieldObj && dataFieldObj.autocomplete) {
                this.$elDropdown.select2('container').attr('autocomplete', dataFieldObj.autocomplete);
            }
        },

        _adaptDropdownCssClasses: function() {
            var transferableClasses = [];
            var elClasses = this.$el[0].className.split(' ');

            var i;

            // transfer dropdown classes to the menu
            for (i = 0; i < elClasses.length; i++) {
                var elClass = elClasses[i];
                if (elClass !== constants.defaultDropdownMicrotheme && elClass.indexOf(constants.dropdownCustomMicrothemesToRetainPrefix) === -1 && elClass.indexOf(constants.dropdownStyleMicrothemesToRetainPrefix) === 0) {
                    transferableClasses.push(elClass.replace(constants.dropdownStyleMicrothemesToRetainPrefix, constants.menuMicrothemePrefix));
                }
            }

            // if no dropdown classes, then transfer form classes to the menu
            if (this.$form.length && transferableClasses.length === 0) {
                var formClasses = this.$form[0].className.split(' ');
                for (i = 0; i < formClasses.length; i++) {
                    var formClass = formClasses[i];
                    if (constants.formMicrothemesMap[formClass]) {
                        transferableClasses.push(constants.formMicrothemesMap[formClass]);
                    } else if (formClass.indexOf(constants.formMicrothemesToRetainPrefix) === 0) {
                        transferableClasses.push(formClass.replace(constants.formMicrothemesToRetainPrefix, constants.menuMicrothemePrefix));
                    }
                }
            }

            if (transferableClasses.length === 0) {
                transferableClasses.push(constants.defaultMenuMicrotheme);
            }

            if (this.$el.hasClass(constants.inputs.css.required)) {
                transferableClasses.push(constants.css.dropdownRequired);
            }

            // finally, tack on any "custom" micro-themes
            for (i = 0; i < elClasses.length; i++) {
                elClass = elClasses[i];
                if (elClass.indexOf(constants.dropdownCustomMicrothemesToRetainPrefix) === 0) {
                    transferableClasses.push(elClass.replace(constants.dropdownCustomMicrothemesToRetainPrefix, constants.menuMicrothemePrefix));
                }
            }

            // tack on the responsive disabled class if we're not mobile
            if (!modernizr.mobiledevice && !this.$el.hasClass(constants.css.dropdownResponsiveDisabled)) {
                transferableClasses.push(constants.css.menuResponsiveDisabled);
            }

            return transferableClasses.join(' ');
        },

        _refreshDropdown: function(context) {
            context || (context = this);
            context.$elDropdown.select2('destroy');
            context._createDropdown();
        },

        _setInitialValue: function(defaultValue) {
            var value;
            var useMetadata = false;

            switch (this.defaultValueType) {
                case 'none':
                    value = '';
                    break;

                case 'datafield':
                    if (!this.inStudio) {
                        if (this.dataContext.hasValue) {
                            defaultValue = this.dataContext.value;
                            useMetadata = this.dataContext.hasMetadata;

                        } else if (this.dataContext.hasDefaultValue) {
                            defaultValue = this.dataContext.defaultValue;
                        }
                    }

                    value = defaultValue;
                    break;

                case 'custom':
                    value = defaultValue;
                    break;
            }

            this.setValue(value, {
                useMetadata: useMetadata
            });
            this.validate(value);
        },

        _setAriaLabelAttribute: function (textFieldLabel) {
            if (!textFieldLabel || !textFieldLabel['id']) return;
            this.$elDropdown.select2('container').attr('aria-labelledby', textFieldLabel.id);
        },

        studioInitialize: function(options) {
            this.deactivateEvents(this.$elDropdown.select2('container'));
        },

        getParamMapOverrides: function() {
            return {
                inputType: this._setInputType,

                defaultValue: function(val) {
                    this.defaultValue = val;
                    if (val === '') {
                        this.$elDropdown.select2('data', '');
                    }
                    this._setInitialValue(this.defaultValue);
                },

                defaultValueType: function(val) {
                    this.defaultValueType = val;
                    this._setInitialValue(this.defaultValue);
                },

                placeholder: function(val) {
                    this.placeholder = val;
                    this._refreshDropdown();
                }
            };
        },

        allowedDropTargets: function(origin) {
            if (origin === 'element'){
                return ['ixp-form-field'];
            }
            return ['ixp-form', 'ixp-form-field'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getScaffolding(scaffoldingKey, builder, options);
        }
    });
})(window.ixp.runtime);